import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AuthenticationService } from '@layouts/login/authentication.service';
import { SharedService } from '@shared/shared.service';

@Injectable()
export class ResetTokenGuard {

  constructor(
    private authenticationService: AuthenticationService,
    private router: Router,
    private sharedService: SharedService
  ) { }

  canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    const token = route.paramMap.get('id');
    if (!token) {
      this.navigateToExpired();
      return of(false);
    }

    return this.authenticationService.ValidateResetToken(token).pipe(
      map((isValid) => {
        if (!isValid) {
          this.navigateToExpired();
          return false;
        }
        return true;
      }),
      catchError((error) => {
        this.sharedService.getErrorMsg(error);
        this.navigateToExpired();
        return of(false);
      })
    );
  }

  private navigateToExpired() {
    this.router.navigate(['/reset-password-expired'], { replaceUrl: true });
  }
}
